<template>
    <DataTable
        :header="$t('listOfProposedProducts')"
        :fields="fields"
        :items="parentComponent.items"
        :loading="parentComponent.loading"
        :error="parentComponent.error"
        :total-rows="parentComponent.requestData.max"
        :current-page.sync="parentComponent.tableParams.page"
        :per-page.sync="parentComponent.tableParams.perPage"
        :sort-by.sync="parentComponent.tableParams.sort"
        :sort-direction.sync="parentComponent.tableParams.order"
        no-sort-reset
        no-local-sorting
    >
        <template #cell(risk)="{item}">
            <Tooltip :html="getRiskHtml(item.risks)" :width="400">{{ item.riskScore }}</Tooltip>
        </template>
        <template #cell(action)="{item}">
            <ButtonIcon size="sm" :to="getItemUrl(item)">
                {{ $t('show') }}
            </ButtonIcon>
        </template>
    </DataTable>
</template>



<script>
    import DataTable from '@/components/common/DataTable.vue';
    import Tooltip from '@/components/common/Tooltip.vue';

    export default {
        name: 'Results',
        components: {
            DataTable,
            Tooltip,
        },
        inject: {
            parentComponent: {
                default: null,
            },
        },
        data() {
            return {};
        },
        computed: {
            fields() {
                return [
                    { key: 'id', label: this.$t('id') },
                    { key: 'risk', label: this.$t('riskValue') },
                    { key: 'aggregation.name', label: this.$t('name') },
                    { key: 'aggregation.info', label: this.$t('author') },
                    { key: 'updatedAt', label: this.$t('updatedAt'), formatter: value => this.$format.date(value) },
                    { key: 'action', label: '' },
                ];
            },
        },
        methods: {
            getItemUrl(item) {
                return {
                    name: 'AggregateModerationDetails',
                    params: { id: item.id, parentUrl: this.$route.params.parentUrl || this.$route.fullPath },
                    query: {},
                };
            },
            getRiskHtml(risk) {
                const data = Object.entries(risk);
                if (data.length) {
                    const items = Object.entries(risk).map(([name, value]) => `<li><strong>${name}</strong>: ${value}</li>`);
                    return `<ul class="pl-3 m-0 d-flex flex-column justify-content-start text-left">${items.join('')}</ul>`;
                }
                return null;
            },
        },
    };
</script>
